import ObjectModelRelation from '~/models/objectModelRelations/objectModelRelation'
import Repo from '~/state/modules/repo'
import IRepo from '~/interfaces/repo'
import Permittee from '~/models/permittee'
import {Hash} from '~/interfaces/hashInterfaces'

export default class ObjectModelRelationUserTypeFilterPermittee extends Permittee<ObjectModelRelation> {
  static repo: IRepo<ObjectModelRelationUserTypeFilterPermittee> = new Repo<ObjectModelRelationUserTypeFilterPermittee>('objectModelRelationUserTypeFilterPermittee', ObjectModelRelationUserTypeFilterPermittee)

  constructor(parent: ObjectModelRelation, json: Hash = {}) {
    super(parent, json, ObjectModelRelationUserTypeFilterPermittee.rootName)
  }

  static get rootName(): string {
    return 'user_type_filters'
  }

  get objectModelRelation(): ObjectModelRelation {
    return this.parent
  }
}